import React from "react";
import cadre1Img from "../../../assets/svg/cadre1.svg";
function ProjetItem({ name, description, github, tecno }) {
  return (
    <div className=" flex flex-col h-96 w-80 project  relative ">
      {/* <img
        alt="dji"
        className="absolute drop-shadow-xl  filter  z-0"
        src={cadre1Img}
      /> */}
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 134 167"
        fill="#58A8F6"
        stroke="#58A8F6"
        xmlns="http://www.w3.org/2000/svg"
        className=" absolute h-full w-full"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M1.05414 6.00388C0.663635 6.39438 0.663635 7.02756 1.05414 7.41806C1.44467 7.80862 2.07785 7.80862 2.46835 7.41806L7.41812 2.46835C7.80862 2.07779 7.80862 1.44461 7.41812 1.05411C7.02759 0.663605 6.39441 0.663605 6.00391 1.05411L1.05414 6.00388ZM2.02194 21.4225C2.02295 21.9084 2.37036 22.3127 2.82999 22.402V145C2.82999 156.14 11.8604 165.17 23 165.17H104.014C104.095 165.641 104.506 166 105 166H117L134 150V138C134 137.506 133.641 137.095 133.17 137.014V22C133.17 10.8604 124.14 1.82999 113 1.82999H23.9856C23.9049 1.35867 23.4943 0.999969 23 0.999969H11L2.08514 11.004L2 11.0042L2.02194 21.4225ZM132 150V138C132 137.506 132.359 137.095 132.83 137.014V22C132.83 11.0482 123.952 2.16995 113 2.16995H23.9856C23.9049 2.64127 23.4943 2.99997 23 2.99997H19.5H13H12.0401L4.00156 11.7389L4.02191 21.4183C4.02298 21.921 3.65295 22.3379 3.17001 22.4095V145C3.17001 155.952 12.0482 164.83 23 164.83H104.014C104.095 164.359 104.506 164 105 164H117L132 150ZM120.505 165.938C120.785 166.244 121.259 166.265 121.565 165.986L132.936 155.614C133.242 155.334 133.264 154.86 132.985 154.554C132.706 154.248 132.231 154.226 131.925 154.505L120.554 164.878C120.248 165.157 120.226 165.631 120.505 165.938ZM126.565 165.655C126.259 165.934 125.785 165.912 125.505 165.606C125.226 165.3 125.248 164.826 125.554 164.547L132.177 158.505C132.483 158.226 132.957 158.248 133.236 158.554C133.516 158.86 133.494 159.334 133.188 159.614L126.565 165.655ZM129.478 165.678C129.214 165.358 129.259 164.886 129.578 164.622L132.174 162.478C132.493 162.214 132.966 162.259 133.23 162.578C133.494 162.898 133.449 163.37 133.129 163.634L130.534 165.778C130.214 166.042 129.741 165.997 129.478 165.678Z"
         strokeWidth={0.5}
      
        />
      </svg>

      <div className="flex z-10 flex-col h-full w-full p-6">
        <div>
          <p className="font-bold text-slate-50"> {name}</p>
          <p className="font-light mt-4   text-slate-50">
            {" "}
            {description.substring(0, 200)}
          </p>
        </div>
        <div>
          <p className="font-bold mt-2 text-slate-50"> Tecnologie</p>

          <p className="font-light ml-3  text-slate-50 flex flex-col">
            {tecno.map((item) => (
              <div className="flex  items-center">
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    class="bi bi-check"
                    viewBox="0 0 16 16"
                  >
                    <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z" />
                  </svg>
                </span>
                <span> {item}</span>
              </div>
            ))}{" "}
          </p>
        </div>
        <div className="flex-grow"></div>
        <a
          href={github}
          className="ring-2 items-center justify-center py-1 mx-5 rounded-lg hover:shadow-2xl hover:shadow-sky-200  text-white bg-gradient-to-tr from-sky-500   ring-sky-400/30  flex  hover:bg-sky-500"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="25"
            fill="currentColor"
            class="bi bi-github mx-3"
            viewBox="0 0 16 16"
          >
            <path d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.012 8.012 0 0 0 16 8c0-4.42-3.58-8-8-8z" />
          </svg>{" "}
          <p>Source Code</p>
        </a>
        <div className="flex-grow"></div>

      </div>
    </div>
  );
}

export default ProjetItem;
